import mitt from 'mitt';

const emitter = mitt();
emitter.$on = emitter.on;
emitter.$off = emitter.off;
emitter.$emit = emitter.emit;

/**
 * Returns the singleton event hub instance for application-wide event communication.
 * @returns {EventHub} The event hub singleton instance
 */
export function useEventHub() {
  return emitter;
}

/**
 * @template {Record<string, unknown>} TEventMap
 * @typedef {import('mitt').Emitter<TEventMap>} Emitter
 */

/**
 * @typedef {Object} EventHub
 * @property {Emitter['on']} on - Subscribe to an event
 * @property {Emitter['on']} $on - Alias for `on`
 * @property {Emitter['off']} off - Unsubscribe from an event
 * @property {Emitter['off']} $off - Alias for `off`
 * @property {Emitter['emit']} emit - Emit an event
 * @property {Emitter['emit']} $emit - Alias for `emit`
 * @property {Emitter['all']} all - Event handler map
 */
